<template>
  <div class="priceTable bg-grey-lighter overflow-hidden py-80">
    <div class="container">
      <h2 class="font-bold">{{ $t('priceTable.Agriculture.projectPrice') }}</h2>
      <div class="my-16 text-center">
        <nav class="tabs btns-horizon inline-block">
          <button class="btn btn-blue" :class="tabActive(1)" @click="nowTab = 1">{{ $t('priceTable.Agriculture.tab01') }}</button>
          <button class="btn btn-blue" :class="tabActive(2)" @click="nowTab = 2">{{ $t('priceTable.Agriculture.tab02') }}</button>
        </nav>
      </div>
      <component :is="camelCase(lang)" :nowTab="nowTab"/>
      <div class="text-center leading-sm text-grey-darker text-sm mt-12">
        <div>{{ $t('priceTable.Agriculture.monthlyLeasing') }}</div>
        <div v-if="$te('priceTable.Agriculture.annotation')">{{ $t('priceTable.Agriculture.annotation') }}</div>
        <!-- *月租費用最短需綁訂合約1年，以此表為參考價格，卻切價格以實際報價單而定 -->
      </div>
      <!-- End of Tab 2 -->
    </div>
  </div>
</template>

<script>
import { camelCase } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import zhTw from './components/zhTw.vue'
import en from './components/en.vue'

export default {
  name: 'priceTable',
  components: {
    zhTw,
    en
  },
  filters: {
    toThousands: function (val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  data () {
    return {
      nowTab: 1
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ])
  },
  methods: {
    ...mapActions([
      'openContactForm'
    ]),
    camelCase,
    openContactFormWithPlan (event, plan) {
      plan ? this.openContactForm({ from: 'Agriculture', plan: plan.name }) : this.openContactForm()
    },
    tabActive: function (tab) {
      return this.nowTab === tab ? 'btn-solid border-1 border-blue text-white' : 'btn-ghost'
    }
  }
}
</script>

<style lang="sass">
.priceTable
  .priceTable__item
    @apply bg-white
.separate-vertical
  &:not(:last-child)
    @apply border-r border-grey-lighter
.separate-horizon
  &:not(:last-child)
    @apply border-b border-grey-lighter pb-8 mb-8
</style>
